export const LOGO_URL = "/logo-pde.png";

export const formShareUrl = (ref) => {
  const base = window.location.origin;
  return ref ? `${base}/?ref=${encodeURIComponent(ref)}` : `${base}/`;
};

export const shareWhatsApp = (ref) => {
  const formUrl = formShareUrl(ref);
  const text = encodeURIComponent(
    `Bonjour 👋\n\nVoici votre fiche énergie Place des Énergies. Remplissez-la en 2 minutes pour être rappelé(e) par notre conseillère et optimiser votre contrat d'énergie :\n${formUrl}`
  );
  window.open(`https://wa.me/?text=${text}`, "_blank");
};

// Header share button: preserves the current ?ref= so the licensee's
// attribution is kept when forwarding the form to a client.
export const shareFormWhatsApp = () => {
  const ref = new URLSearchParams(window.location.search).get("ref");
  shareWhatsApp(ref || undefined);
};
